// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';

const selectHarvestEventsLoadParams = createDeepEqualSelector(
    [selectCurrentOrganizationId, selectCurrentSeasonId, selectCurrentEntityId],
    (
        currentOrganizationIdState: string | undefined,
        selectCurrentSeasonIdState: number | undefined,
        currentEntityIdState: number | undefined
    ) => ({
        organizationId: currentOrganizationIdState,
        filter: {
            eager:
                '[quantitySchedules, harvestEvent, jobs.[assignedUsers], harvestEventStats]',
            where: {
                'quantitySchedules.deletedAt': { $exists: false }
            },
            require: {
                $and: [
                    {
                        deletedAt: { $exists: false },
                        'entity.archivedAt': { $exists: false },
                        ...(selectCurrentSeasonIdState
                            ? { 'entity.seasonId': selectCurrentSeasonIdState }
                            : {}),
                        'schema.eventTypeId': 'HARVEST',
                        ...(currentEntityIdState
                            ? {
                                  $or: [
                                      {
                                          'entity.path': {
                                              $like: `/${currentEntityIdState}/%`
                                          }
                                      },
                                      {
                                          entityId: currentEntityIdState
                                      }
                                  ]
                              }
                            : {})
                    }
                ]
            },
            order: 'quantitySchedules.date asc, jobs.jobType asc',
            fields: [
                'createdAt',
                'entityId',
                'entityName',
                'forecastedQuantity',
                'groupIds',
                'harvestEvent.colorGrade',
                'harvestEvent.harvestBinSuitabilityId',
                'harvestEvent.harvestGrowingMethodId',
                'harvestEvent.harvestLocationId',
                'harvestEvent.harvestPalletTypeId',
                'harvestEvent.harvestStorageTypeId',
                'harvestEvent.harvestSubmissionProfileId',
                'harvestEvent.pickTypeId',
                'harvestEventStats.numberOfContainers',
                'harvestEventStats.overallDefectPercentage',
                'id', // Required for timeline, look to remove in refactor.
                'isDifferentFromForecast',
                'jobs.assignedUsers.email',
                'jobs.jobType',
                'jobs.jobState',
                'orderedAt',
                'pickTypeName',
                'quantitySchedules.date',
                'quantitySchedules.value',
                'varietyName',
                'uuid'
            ]
        }
    })
);

export { selectHarvestEventsLoadParams };
